export enum FeatureFlagKey {
  EnableMyEmergencyPlan = 'enableMyEmergencyPlan',
}
